import FabView from './FabView';
export default FabView;
